import React from 'react';
import { Facebook, Instagram, Twitter } from 'lucide-react';
import { TRANSLATIONS } from './translations';

const Footer = ({ lang }: { lang: 'en' | 'ar' }) => {
    const currentLang = TRANSLATIONS[lang] ? lang : 'en';
    const t = TRANSLATIONS[currentLang];

    return (
        <footer className="bg-gray-50 border-t border-gray-100 pt-16 pb-8">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-5 gap-12 mb-12">
                    {/* Brand Column */}
                    <div className="col-span-1 md:col-span-1">
                        <div className="flex items-center gap-2 mb-6">
                            <img src="/assets/images/logo_como.png" alt="COMO" className="h-12 w-auto object-contain" width="130" height="48" />
                        </div>
                        <p className="text-gray-500 text-sm leading-relaxed mb-6">
                            {t.footer.brandDesc}
                        </p>
                        <div className="flex gap-4">
                            <a href="https://www.facebook.com/Comotravels" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-400 hover:text-blue-600 hover:border-blue-600 transition-all cursor-pointer"><Facebook className="w-5 h-5" /></a>
                            <a href="https://www.instagram.com/comotravels" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-400 hover:text-pink-600 hover:border-pink-600 transition-all cursor-pointer"><Instagram className="w-5 h-5" /></a>
                            <a href="https://x.com/comotravels" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)" className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-400 hover:text-black hover:border-black transition-all cursor-pointer"><Twitter className="w-5 h-5" /></a>
                            <a href="https://www.tiktok.com/@comotravels.com" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-400 hover:text-black hover:border-black transition-all cursor-pointer">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" /></svg>
                            </a>
                        </div>
                    </div>

                    {/* Important Pages */}
                    <div>
                        <h4 className="font-bold text-gray-900 mb-6">{t.footer.titles.pages}</h4>
                        <ul className="space-y-4 text-gray-500 text-sm">
                            {t.footer.links.pages.map((link: { label: string; href: string }) => (
                                <li key={link.label}>
                                    <a href={link.href} className="hover:text-blue-600 cursor-pointer transition-colors">
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Services */}
                    <div>
                        <h4 className="font-bold text-gray-900 mb-6">{t.footer.titles.services}</h4>
                        <ul className="space-y-4 text-gray-500 text-sm">
                            {t.footer.links.services.map((link: { label: string; href: string }) => (
                                <li key={link.label}>
                                    <a href={link.href} className="hover:text-blue-600 cursor-pointer transition-colors">
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Legal */}
                    <div>
                        <h4 className="font-bold text-gray-900 mb-6">{t.footer.titles.legal}</h4>
                        <ul className="space-y-4 text-gray-500 text-sm">
                            {t.footer.links.legal.map((link: { label: string; href: string }) => (
                                <li key={link.label}>
                                    <a href={link.href} className="hover:text-blue-600 cursor-pointer transition-colors">
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Support */}
                    <div>
                        <h4 className="font-bold text-gray-900 mb-6">{t.footer.titles.support}</h4>
                        <ul className="space-y-4 text-gray-500 text-sm">
                            {t.footer.links.support.map((link: { label: string; href: string }) => (
                                <li key={link.label}>
                                    <a href={link.href} className="hover:text-blue-600 cursor-pointer transition-colors">
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="border-t border-gray-200 pt-8 text-center text-sm text-gray-600">
                    {t.footer.rights}
                </div>
            </div>
        </footer>
    );
};

export default Footer;
